export default "/assets/images/tech_page_04.d60dcf3b2971fc90.mp4";